/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { CognitoStrictHttpResponse } from '../../cognito-strict-http-response';
import { CognitoRequestBuilder } from '../../cognito-request-builder';

import { CognitoCognitoUserUpdateDto } from '../../models/cognito-cognito-user-update-dto';
import { CognitoMessageResponseDto } from '../../models/cognito-message-response-dto';

export interface CognitoControllerUpdateUser$Params {

/**
 * The tenant identifier
 */
  tenant: string;

/**
 * The ID (sub) of the user to update
 */
  id: string;
      body: CognitoCognitoUserUpdateDto
}

export function cognitoControllerUpdateUser(http: HttpClient, rootUrl: string, params: CognitoControllerUpdateUser$Params, context?: HttpContext): Observable<CognitoStrictHttpResponse<CognitoMessageResponseDto>> {
  const rb = new CognitoRequestBuilder(rootUrl, cognitoControllerUpdateUser.PATH, 'patch');
  if (params) {
    rb.path('tenant', params.tenant, {});
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as CognitoStrictHttpResponse<CognitoMessageResponseDto>;
    })
  );
}

cognitoControllerUpdateUser.PATH = '/o2-cognito/cognito/users/{tenant}/{id}';
